var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4999 2.08334C18.2529 2.08334 22.9166 6.747 22.9166 12.5C22.9166 18.253 18.2529 22.9167 12.4999 22.9167C6.74697 22.9167 2.08325 18.253 2.08325 12.5C2.08325 6.747 6.74697 2.08334 12.4999 2.08334ZM13.5439 11.4583H11.4605V17.7083H13.5439V11.4583ZM12.5105 7.03126C11.751 7.03126 11.2001 7.57912 11.2001 8.3189C11.2001 9.08859 11.7365 9.63543 12.5105 9.63543C13.2544 9.63543 13.8043 9.08859 13.8043 8.33334C13.8043 7.57912 13.2544 7.03126 12.5105 7.03126Z",
    fill: "#52447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutFilled);
export default __webpack_public_path__ + "static/media/about-filled.04c13a6eeea7463dc44763a9f2d203bf.svg";
export { ForwardRef as ReactComponent };